<template>
  <div class="stats-probs" :class="dynamicClasses">
    <div class="stats-probs__container" v-for="(item, index) in items" :key="`sp-item-${index}`">
      <div class="title" :style="titleStyles">
        <span>{{ item.title }}</span>
      </div>
      <div class="content">
        <span>
          <template v-if="item.content == '0%'">
            -
          </template>
          <template v-else>
            {{ item.content }}
          </template>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StatsContainer',
  props: {
    titles: {
      type: Array,
      required: true,
    },
    contents: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
      default: '#fff',
    },
    background: {
      type: String,
      default: '#DBE3E6',
    },
    containerWidth: {
      type: Number,
      default: 634,
    },
    isSingleGame: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return this.titles.map((_, index) => {
        return {
          title: this.titles[index],
          content: this.contents[index],
        };
      });
    },
    titleStyles() {
      return {
        color: '#000000',
        background: '#DBE3E6',
      };
    },
    dynamicClasses() {
      const dynamicClasses = [];
      if (this.isSingleGame) {
        dynamicClasses.push('single-game');
        if (this.containerWidth < 451) {
          dynamicClasses.push('first-break-point');
        }
      } else {
        if (this.containerWidth < 636) {
          dynamicClasses.push('first-break-point');
        }
      }
      return dynamicClasses;
    },
  },
};
</script>

<style lang="scss" scoped>
.stats-probs {
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #132839;

  & .title,
  & .content {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.6rem;
    margin: 1px 0;
    line-height: 1.2;
  }

  & .title {
    font-family: Avenir-Demi, sans-serif;
    font-size: 0.875rem;
    padding: 0.5em 4px 0.3em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: -0.28px;
    text-align: center;
  }
  & .content {
    font-family: Avenir-Bold, sans-serif;
    font-size: 1rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: -0.3px;
    text-align: center;
    margin-top: 0.8em;
  }

  &__container {
    width: 100%;
    &:first-child {
      & .title {
        border-radius: 6px 0 0 6px;
      }
    }
    &:last-child {
      & .title {
        border-radius: 0 6px 6px 0;
      }
    }
  }

  &.single-game {
    & .title {
      font-size: 1rem;
    }
    & .content {
      font-size: 0.8rem;
      margin-bottom: 0.4rem;
    }

    &.first-break-point {
      & .title {
        font-size: 0.57rem;
      }
      & .content {
        font-size: 0.625rem;
      }
    }
  }

  &.first-break-point {
    & .title {
      font-size: 0.57rem;
    }
    & .content {
      font-size: 0.625rem;
    }
  }
}
</style>
